import React from "react";

import styled from "styled-components";

import { Styles } from "../../config";

const _recursivelyTraverseListItems = ({
  color,

  item,
  listStyle,
  weight,
  variant,
  level,
  subVariant,
}) => {
  if (!item) return;

  if (!Array.isArray(item)) {
    return (
      <ListItem
        key={item}
        listStyle={level === 0 ? listStyle : "none"}
        weight={weight}
        variant={level === 0 ? variant : subVariant || variant}
        color={color}
        level={level}
      >
        {item}
      </ListItem>
    );
  } else
    return item.map((subItem) => {
      return _recursivelyTraverseListItems({
        color,

        item: subItem,
        listStyle,
        weight,
        variant,
        level: level + 1,
        subVariant,
      });
    });
};


const ListItem = styled.li`
  list-style: ${(props) => props.listStyle || "disc"};
  color: ${(props) =>
    props.color ? Styles.Color[props.color] : Styles.Color.primary};
  weight: ${(props) => props.weight || "400"};
  font-size: ${(props) => Styles.FontSize[props.variant]?.size};
  margin: 0 0 0 ${(props) => props.level * 25}px;
  @media only screen and (max-width: 800px) {
    font-size: ${(props) => Styles.FontSize[props.variant]?.mobileSize};
  }
`;



const List = ({
  items,
  margin,
  variant,
  style,
  color,
  weight,
  listStyle,

  subVariant,
}) => {

  return (
    <div style={{ margin: margin || "20px 0", width: "100%", ...style }}>
      <ul style={{ margin: "0" }}>
        {items.map((item) => {
          return _recursivelyTraverseListItems({
            color,

            item,
            listStyle,
            weight,
            variant,
            level: 0,
            subVariant,
          });
        })}
      </ul>
    </div>
  );
};

export default List;
